import {LoadingAnimation} from '../Components/LoadingAnimation';

export function initLoadingAnimation(submitButtonElement: HTMLButtonElement, formWrapperElement: HTMLElement, formSelector: string): void {
  const form = document.querySelector(formSelector);
  if (!form) {
    return;
  }

  form?.addEventListener('submit', () => {
    if (submitButtonElement) {
      const loadingAnimation = new LoadingAnimation(`${formSelector} .js-loadingAnimation`);
      submitButtonElement.classList.add('button--inactive');
      submitButtonElement.disabled = true;
      if (loadingAnimation) {
        loadingAnimation.showLoadingAnimation();
      }
    }

    if (formWrapperElement) {
      formWrapperElement.classList.add('contactforms--loading');
    }
  });
}
